import { createSetThreadIdMessage } from 'calling-global-api/lib/internalEventMessageCreators';
import { postInternalMessage } from '../initialize';
export default function updateThreadIdHandler({
  threadId
}) {
  const message = createSetThreadIdMessage(threadId);
  postInternalMessage(message);
}